/**
 * @module Annual Report - Tooltips
 * @description JS for Annual Report Template - Tooltips
 */



/**
 * @function getTooltip
 * @description Hide or Display the tooltip
 */
const getTooltip = ( event ) => {
  const { target } = event;
  const parent = target.parentNode;
  const tooltip = parent.querySelector( '.tooltip__box' );

  return tooltip;
}

/**
 * @function setTooltipDisplay
 * @description Hide or Display the tooltip
 */
const setTooltipDisplay = ( isVisible = false, tooltip = null ) => {
  if( ! tooltip ) {
    return;
  }

  tooltip.setAttribute( 'aria-hidden', ( isVisible === true ? false : true ) );
  tooltip.style.display = isVisible === true ? 'block' : 'none';
}


/**
* @function hideToolTip
* @description Hide the tooltip
*/
const hideTooltip = ( event ) => {
  const tooltip = getTooltip( event );
  setTooltipDisplay( false, tooltip );
}

/**
 * @function showTooltip
 * @description Show The tooltip
 */
const showTooltip = ( event ) => {
  const tooltip = getTooltip( event );
  setTooltipDisplay( true, tooltip );
}


/**
 * @function bindArrowEvents
 * @description Bind arrow events for this module
 */
const bindEvents = ( tooltip ) => {
  tooltip.addEventListener( 'mouseover', showTooltip );
  tooltip.addEventListener( 'mouseout', hideTooltip );
}

/**
 * @function init
 * @description Kick off this modules functions
 */
const init = ( tabset ) => {
  const tooltips = tabset.querySelectorAll( '.tooltip__icon' );

  tooltips.forEach( ( tooltip ) => {
    bindEvents( tooltip );
  } );
}

export default init
